


import './career.css';
import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/Constructure.png'
import Aboutbg from '../Images/s5.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "Our Construction division delivers high-quality, safe, and eﬃcient solutions  across  a  wide  range  of sectors,  including  oil  &  gas,  infrastructure,  energy, and  industrial  facilities.",
    intro2:
      "At Jeyshawn Engineering Limited, we provide comprehensive Camp Setup Services designed to support oil and gas operations, construction projects, infrastructure developments and remote workforce deployments. We understand that a well-planned and properly managed camp environment is essential for productivity, safety, and employee well-being.",
    intro:
      "Backed  by  experienced professionals  and  robust  project  management systems,  we  execute  civil,  mechanical,  structural and  electrical  construction  works  to  global standards. From site preparation and fabrication to installation and commissioning, we are committed to delivering projects within budget and with a strong focus  on  safety  and  quality.",

    intro1:
      "Our  ability  to  manage complex  construction  environments  ensures seamless  integration  with  engineering  and procurement functions for optimal project delivery.",
    intro3:
      "Our team delivers turnkey camp solutions that ensure personnel have access to secure accommodation, reliable utilities, quality welfare facilities and a conducive living environment throughout the project lifecycle.",
  }
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];


export default function Construction() {
  return (
    <>
      <div className="img_carriercon">
        <img src={Avatar1} alt="" />
      </div>

      {/* <div className="construction_herder_img">
        <img src="" alt="" className="const_header_img" />
        <img src="" alt="" className="const_header_img" />
      </div> */}

      <section className="service-detail" style={{ backgroundImage: `url(${Aboutbg})` }}>
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
          <p 
  className="intro-text mkbold remove_margin" 
  style={{ color: '#008000', }}
> 
  Camp Setup 
</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
            <p className="service-detail__intro">{services[0].intro3}</p>

            
        {/* Introduction */}
        <p className="intro-text mkbold">
          Our Camp Setup Services Includes:
        </p>

        {/* List of Areas */}
        <ul className="catext">
          <li className=''>	Site Preparation and Development.</li>
          <li className=''>	Accommodation Facilities.</li>
          <li className=''> Utility Installation.</li>
          <li className=''> Catering and welfare operations.</li>
          <li className=''> Advanced safety and security solution.</li>
          <li className=''>	Operations, maintenance and decommissioning.</li>

          {/* <p className="intro-text">Our People & Culture</p>
          <p>We foster a diverse and inclusive workplace that encourages collaboration, innovation, and respect. Our team work together to solve complex challenges while maintaining the highest standards of safety and operational excellence.</p>
          <p className="intro-text" style={{marginTop:"10px"}}>Join Our Team</p>
          <p>If you are motivated, safety-conscious, and ready to contribute to the future of the oil and gas industry, we invite you to explore career <span className="highlight">opportunities</span>. with us.</p> */}
        </ul>
            {/* {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))} */}
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer/>
    </>
  );
}


 